import Vue from 'vue'

export default new Vue({
  data: {
    isLogged: false
  }
})
